import { MChapter } from './chapter.model';
import { ChapterData } from '../interfaces/Organization';
import { MProcess } from './process.model';

export class MChapterData{
    public activeRequirements: number;
    public conformedRequirements: number;
    public evaluatedRequirements: number;
    public nonConformedRequirements: number;
    public nonEvaluatedRequirements: number;
    public chapter: MChapter = null;
    public score: number;
    public maxScore: number;
    public effectiveness: number;
    public processes: MProcess[] = [];
    public mandatory: boolean = false;

    constructor(chap: ChapterData){
        this.activeRequirements = parseInt(chap.req_activos);
        this.evaluatedRequirements = parseInt(chap.req_evaluados);
        this.conformedRequirements = parseInt(chap.req_conformes);
        this.nonConformedRequirements = parseInt(chap.req_no_conformes);
        this.nonEvaluatedRequirements = parseInt(chap.req_no_evaluados);
        if (chap.capitulo) {
            this.chapter = new MChapter(chap.capitulo)
        } else if(chap.apartado) {
            this.chapter = new MChapter(chap.apartado)
        } else if (chap.item) {
            this.chapter = new MChapter(chap.item)
        } else if (chap.requisito) {
            this.chapter = new MChapter(chap.requisito)
            if (chap.requisito.obligatorio) {
                this.mandatory = chap.requisito.obligatorio == '1';
            }
        }
        if (this.evaluatedRequirements > 0) {
            this.score = Math.ceil((this.conformedRequirements / this.activeRequirements) * 100)
            this.effectiveness = Math.ceil((this.conformedRequirements / this.evaluatedRequirements) * 100)
        } else {
            this.score = 0;
            this.effectiveness = 0;
        }
        if (chap.procesos) {
            for (let i = 0; i < chap.procesos.length; i++) {
                this.processes.push(new MProcess(chap.procesos[i]));     
            }
        }
    }
}